export const getVideos = (state) =>
  state.videos;



// WEBPACK FOOTER //
// ./src/store/selectors/videos.js